
export const FAUNA_SECRET = 'fnAE5GSetyACWhilNDTrQfkSm8EC0ifNhZkwIMQI';
